export { default } from './DestacatHistoric';
